






import { Component, Vue } from 'vue-property-decorator'
@Component({
  name: 'HistoryRecord',
  components: {
    'in-development': () => import('../../components/common/inDevelopment.vue')
  }
})
export default class HistoryRecord extends Vue {

}
